
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoharihareshwartaxi() {



    const cardData =
    {
        keyword: 'Pune to Harihareshwar Taxi',
        heading: 'Platinum24 Cabs: Pune to Harihareshwar Taxi',
        headingDescription: ' Platinum24 Cabs offers reliable Pune to Harihareshwar Taxi services, ideal for family trips, beach holidays, and pilgrimage tours. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a comfortable journey along the scenic Konkan coastline, with spacious seating and smooth rides. With experienced chauffeurs, timely pickups, and transparent fares, we make your travel to the sacred Harihareshwar Temple and serene beaches completely hassle-free. Whether you’re planning a weekend getaway, a coastal tour, or a family vacation, Platinum24 Cabs guarantees safe, punctual, and enjoyable travel from Pune to Harihareshwar.',

        top: 'Top Places to Visit in Harihareshwar with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Harihareshwar Beach",
    "description": "Harihareshwar Beach is a serene coastal stretch surrounded by hills and forests, making it one of the most peaceful beaches in Konkan. The black sand and gentle waves make it perfect for relaxation and long walks. Tourists enjoy local seafood delicacies at beachside shacks. It is less commercialized compared to Alibaug or Goa, offering raw natural beauty. Sunsets here are enchanting with golden hues over the Arabian Sea. Harihareshwar Beach is the town’s natural paradise."
  },
  {
    "title": "Harihareshwar Temple",
    "description": "The Harihareshwar Temple, dedicated to Lord Shiva, is the spiritual heart of the town. Known as ‘Dakshin Kashi,’ it holds immense religious importance in Maharashtra. The temple complex includes shrines of Kalbhairav and Yogeshwari Devi. Pilgrims also perform the Parikrama path around the temple hill, which passes along the rocky seashore. Festivals like Shivratri attract thousands of devotees. Harihareshwar Temple is the region’s sacred spiritual landmark."
  },
  {
    "title": "Parikrama Path",
    "description": "The Parikrama Path is a unique pilgrimage walk around the Harihareshwar Temple hill. Pilgrims walk along a rocky trail beside the sea, surrounded by cliffs and waves. It is believed that completing this parikrama washes away sins. The path is adventurous, especially in monsoon when waves crash dramatically on rocks. The trail offers mesmerizing sea views. The Parikrama Path is Harihareshwar’s sacred and scenic spiritual journey."
  },
  {
    "title": "Shrivardhan Beach",
    "description": "Shrivardhan Beach, located 20 km from Harihareshwar, is known for its wide sandy stretch and peaceful environment. Tourists enjoy water sports, camel rides, and beach picnics. The town is also historically significant as the birthplace of Peshwa Balaji Vishwanath. Clean shores and palm trees add charm. It is a favorite weekend spot for families from Pune and Mumbai. Shrivardhan Beach is Harihareshwar’s nearby coastal retreat."
  },
  {
    "title": "Diveagar Beach",
    "description": "Diveagar Beach, 35 km from Harihareshwar, is a hidden gem with soft sands, coconut groves, and a peaceful vibe. The village is famous for its Suvarna Ganesh Temple, once home to a golden idol. Tourists enjoy horse rides, quad biking, and seafood. The beach is less crowded, perfect for solitude and relaxation. Birdwatchers love spotting seagulls and migratory birds here. Diveagar is Harihareshwar’s quiet seaside escape."
  },
  {
    "title": "Bagmandala",
    "description": "Bagmandala is a ferry point near Harihareshwar that connects travelers to Bankot across the Savitri River. The ride offers scenic river and mangrove views. Bagmandala is also known for its local fish markets and coastal culture. It serves as a gateway to explore historic forts and villages nearby. The peaceful setting attracts photographers and nature lovers. Bagmandala is Harihareshwar’s riverside charm."
  },
  {
    "title": "Bankot Fort",
    "description": "Bankot Fort, located across the Savitri River from Harihareshwar, is a historic Maratha stronghold. It offers panoramic views of the Arabian Sea and surrounding landscapes. The fort has watchtowers, ramparts, and ancient structures narrating tales of Maratha and Portuguese rule. Trekkers enjoy exploring its ruins amidst nature. Its strategic location makes it historically significant. Bankot Fort is Harihareshwar’s proud heritage sentinel."
  },
  {
    "title": "Velas Beach",
    "description": "Velas Beach, near Harihareshwar, is famous for the Olive Ridley Turtle Festival. During the nesting season, conservationists release turtle hatchlings into the sea, attracting eco-tourists. The village offers homestays where visitors experience authentic Konkani culture. The beach itself is quiet, clean, and lined with coconut trees. Nature lovers and families find it highly educational and inspiring. Velas Beach is Harihareshwar’s eco-tourism gem."
  },
  {
    "title": "Ganesh Gully",
    "description": "Ganesh Gully is a narrow passage between two rocky hills near Harihareshwar Temple. Legends say Lord Ganesh once passed through this narrow lane. During low tide, devotees walk through to reach a hidden Ganesh idol carved into the rocks. The adventure of crossing waves and rocks makes it exciting. It is both a spiritual and scenic spot. Ganesh Gully is Harihareshwar’s hidden religious wonder."
  },
  {
    "title": "Kalbhairav Temple",
    "description": "Kalbhairav Temple, part of the Harihareshwar temple complex, is dedicated to Lord Kalbhairav, the protector deity. Devotees believe darshan here completes their pilgrimage. The temple is surrounded by forests and sea, adding a mystical charm. Rituals and festivals bring it alive with devotion. It is less crowded than the main shrine, offering peace. Kalbhairav Temple is Harihareshwar’s guardian shrine of faith."
  }
],



   "services": [
    {
      "name": "Pune to Harihareshwar Cab",
      "description": "Book a reliable and comfortable cab from Pune to Harihareshwar for a peaceful journey to the scenic coastal town. Ideal for families, beach lovers, and spiritual travelers, this service offers door-to-door pickup, professionally trained drivers, and clean, air-conditioned vehicles. Enjoy a hassle-free road trip with route flexibility and roadside break options. Choose from hatchbacks, sedans, SUVs, or premium vehicles depending on your group size and comfort needs."
    },
    {
      "name": "Harihareshwar Taxi Service Pune",
      "description": "Our Harihareshwar taxi service from Pune offers 24/7 availability with well-maintained cars and expert drivers familiar with the Konkan region. Whether you're planning a family outing, a weekend beach trip, or a pilgrimage to the famous Harihareshwar temple, we ensure a safe, timely, and comfortable travel experience. Vehicles come equipped with GPS, music systems, and sanitization protocols. Custom stops and sightseeing along the way are available on request."
    },
    {
      "name": "Pune to Harihareshwar Taxi Booking",
      "description": "Easily book your taxi from Pune to Harihareshwar online or via call with instant confirmation and flexible booking options. Choose the vehicle category, select your pickup time and location, and enjoy real-time booking support. Our system ensures secure payment options, trip updates, and rescheduling flexibility. Book early to avail discounted fares and enjoy a seamless journey from Pune to the serene shores of Harihareshwar."
    },
    {
      "name": "Taxi from Pune to Harihareshwar",
      "description": "Hire a taxi from Pune to Harihareshwar for a scenic and stress-free journey to the coastal town. Enjoy the scenic beauty of the Western Ghats and Konkan belt with experienced drivers who are well-versed with the terrain. Taxis are available in multiple seating capacities, including 4-seaters and 7-seaters. Ideal for families, couples, or small groups planning beach getaways, temple visits, or nature trips."
    },
    {
      "name": "Harihareshwar Cab Rental Pune",
      "description": "Get access to flexible cab rentals from Pune to Harihareshwar, available on an hourly, daily, or per-trip basis. Suitable for personal, religious, and group travel, our rental plans include fuel, driver charges, and optional return trips. Our fleet includes compact cars, sedans, SUVs, and tempo travellers. You can also request additional services like sightseeing detours, extra luggage space, or overnight halts along the way."
    },
    {
      "name": "Pune to Harihareshwar Taxi Fare",
      "description": "Get transparent fare details for your Pune to Harihareshwar trip with complete cost breakdowns, including fuel, driver allowances, tolls, and taxes. We offer fixed pricing based on distance and vehicle type, with no hidden charges. Fare varies depending on sedan, SUV, or luxury selection. Custom quotes available for round trips, group bookings, and weekend plans. Get the best price with assured quality service."
    },
    {
      "name": "Cab Service Pune to Harihareshwar",
      "description": "Professional cab services from Pune to Harihareshwar with punctual pickup, courteous chauffeurs, and safe vehicles. Our cabs are equipped with comfortable seats, AC, music system, and emergency kits. Perfect for weekend beach holidays, family trips, or peaceful temple visits. Our service emphasizes customer satisfaction, on-road support, and flexible timings to ensure a worry-free travel experience from Pune to the coast."
    },
    {
      "name": "Pune Harihareshwar Private Taxi",
      "description": "Opt for a private taxi from Pune to Harihareshwar for a personalized and exclusive travel experience. No ride-sharing, no delays—just point-to-point comfort. Private taxis come with spacious interiors, experienced drivers, and a choice of vehicles from economy to luxury. Ideal for couples, families, or small groups who want complete privacy, comfort, and convenience during their trip to the serene Konkan coastline."
    },
    {
      "name": "Harihareshwar Taxi Charges Pune",
      "description": "Understand detailed taxi charge structures for Pune to Harihareshwar travel. Charges include driver fee, fuel, and intercity tolls, with options to upgrade to luxury or SUV vehicles. Our transparent pricing policy means you’ll know the exact fare before confirming your booking. Compare prices across car types and find the best deal tailored to your travel schedule and group size."
    },
    {
      "name": "Pune to Harihareshwar Car Hire",
      "description": "Hire a car for your Pune to Harihareshwar journey with chauffeur or self-drive options. Enjoy flexible rental durations, including half-day, full-day, and multi-day plans. Choose from compact cars for solo or couple travel, or larger vehicles for group tours. Our car hire packages come with insurance, support, and optional add-ons like beach kits, Wi-Fi, or extra driver assistance."
    },
    {
      "name": "Harihareshwar Taxi Packages Pune",
      "description": "All-inclusive taxi packages for Pune to Harihareshwar that cover everything—fuel, driver charges, tolls, parking, and even optional sightseeing. Packages are ideal for family trips, spiritual journeys, or photography tours. Available for one-day, two-day, or custom duration trips, with add-ons like meal stops, multiple drop points, and return trip flexibility. Book online or through our support team for quick confirmation."
    },
    {
      "name": "Harihareshwar Cab for Family Trips Pune",
      "description": "Specialized cabs for family trips from Pune to Harihareshwar with extra space, child safety features, and polite drivers who understand family travel needs. Enjoy a calm and joyful ride in AC vehicles with sufficient luggage space, comfort breaks, and assistance for senior citizens. Ideal for vacations to the beach, temples, or scenic spots along the Konkan coast."
    },
    {
      "name": "Pune to Harihareshwar Outstation Taxi",
      "description": "Outstation taxi service from Pune to Harihareshwar designed for long-distance, multi-hour journeys. Enjoy smooth rides in vehicles that are serviced for safety and performance. Drivers are trained for intercity driving and road familiarity. Service includes one-way, round-trip, and overnight options. Emergency assistance and travel insurance coverage available for added peace of mind."
    },
    {
      "name": "Harihareshwar Taxi for Pilgrimage Pune",
      "description": "Dedicated taxi services from Pune to Harihareshwar for pilgrimage and spiritual trips. Visit the sacred Harihareshwar temple in comfort, with drivers who respect the spiritual nature of your journey. Stopovers at other temples or religious places along the way can be added. Ideal for individual devotees, elderly passengers, and spiritual tour groups seeking a serene and respectful travel experience."
    },
    {
      "name": "Pune to Harihareshwar One Way Cab",
      "description": "Book a budget-friendly one-way cab from Pune to Harihareshwar and pay only for the distance you travel. Perfect for solo travelers, friends, or families with a fixed stay plan. No hidden return charges. Choose from economy to premium vehicles and enjoy doorstep pickup, safety protocols, and smooth rides through the scenic route to the coast."
    }
  ],
  "tableData": [
    ["Pune to Harihareshwar Cab", "Harihareshwar Taxi Service Pune"],
    ["Pune to Harihareshwar Taxi Booking", "Taxi from Pune to Harihareshwar"],
    ["Harihareshwar Cab Rental Pune", "Pune to Harihareshwar Taxi Fare"],
    ["Cab Service Pune to Harihareshwar", "Pune Harihareshwar Private Taxi"],
    ["Harihareshwar Taxi Charges Pune", "Pune to Harihareshwar Car Hire"],
    ["Harihareshwar Taxi Packages Pune", "Harihareshwar Cab for Family Trips Pune"],
    ["Pune to Harihareshwar Outstation Taxi", "Harihareshwar Taxi for Pilgrimage Pune"],
    ["Pune to Harihareshwar One Way Cab", "—"]
  ],


         "whychoose": [
    {
      "WhyChooseheading": "Reliable Pune to Harihareshwar Taxi Service",
      "WhyChoosedescription": "Platinum24 Cabs offers comfortable and dependable taxi rides from Pune to Harihareshwar for a smooth travel experience."
    },
    {
      "WhyChooseheading": "Timely Pickups to Ensure On-Time Arrival",
      "WhyChoosedescription": "Our drivers prioritize punctuality so you reach Harihareshwar without any hassle."
    },
    {
      "WhyChooseheading": "Clean and Comfortable Vehicles for Long Journeys",
      "WhyChoosedescription": "Travel in air-conditioned, well-maintained taxis designed for comfort and convenience."
    },
    {
      "WhyChooseheading": "Experienced Drivers with Local Route Knowledge",
      "WhyChoosedescription": "Our skilled drivers know the best routes for a safe and efficient trip between Pune and Harihareshwar."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront pricing that includes fuel, tolls, and driver allowances for stress-free travel."
    },
    {
      "WhyChooseheading": "Flexible Booking for One-Way and Round Trips",
      "WhyChoosedescription": "Choose from customizable packages tailored to your travel itinerary."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Hassle-Free Bookings",
      "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with your taxi needs."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Requirements",
      "WhyChoosedescription": "Select from hatchbacks, sedans, or SUVs depending on your group size and luggage."
    }
  ]























    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide taxi services from Pune to Harihareshwar?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable taxi services for travel between Pune and Harihareshwar.',
    },
    {
        question: 'How can I book a taxi from Pune to Harihareshwar with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Harihareshwar taxi through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Harihareshwar trips?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars to suit your travel preferences and group size.',
    },
    {
        question: 'Are the drivers experienced for long-distance travel like Pune to Harihareshwar?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about the Pune to Harihareshwar route.',
    },
    {
        question: 'Can I book a round trip taxi from Pune to Harihareshwar?',
        answer: 'Absolutely! We provide round-trip taxi services with flexible scheduling to accommodate your travel plans.',
    },
    {
        question: 'What is included in the fare for Pune to Harihareshwar taxi services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Harihareshwar rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune-Harihareshwar route.',
    },
    {
        question: 'Are safety measures in place for Pune to Harihareshwar taxi rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Is it possible to hire a taxi for multiple days for Pune to Harihareshwar travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your travel needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services from Pune to Harihareshwar?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for Pune to Harihareshwar routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Prakash Shinde',
        feedback: 'The taxi service from Pune to Harihareshwar by Platinum24 Cabs was excellent. The driver was punctual and the vehicle comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Kavita Desai',
        feedback: 'Booking a taxi to Harihareshwar was smooth and hassle-free. The service was professional and reliable.',
        rating: 5,
    },
];






































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const puneToHarihareshwarTaxiSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Harihareshwar Taxi",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-harihareshwar-taxi.jpg",
  "description": "Book reliable Pune to Harihareshwar taxi service for family trips, pilgrimage, and outstation travel. Affordable private cabs with verified drivers at Platinum24 Cabs.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1900",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-harihareshwar-taxi"
  }
};








    return (
        <div>

<Helmet>
  <title>Pune to Harihareshwar Taxi | Affordable Private Cabs | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book reliable Pune to Harihareshwar taxi service for family trips, pilgrimage, and outstation travel. Affordable private cabs with verified drivers at Platinum24 Cabs."
  />
  <meta
    name="keywords"
    content="Pune to Harihareshwar Cab, Harihareshwar Taxi Service Pune, Pune to Harihareshwar Taxi Booking, Taxi from Pune to Harihareshwar, Harihareshwar Cab Rental Pune, Pune to Harihareshwar Taxi Fare, Cab Service Pune to Harihareshwar, Pune Harihareshwar Private Taxi, Harihareshwar Taxi Charges Pune, Pune to Harihareshwar Car Hire, Harihareshwar Taxi Packages Pune, Harihareshwar Cab for Family Trips Pune, Pune to Harihareshwar Outstation Taxi, Harihareshwar Taxi for Pilgrimage Pune, Pune to Harihareshwar One Way Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToHarihareshwarTaxiSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/26.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoharihareshwartaxi;